import { render } from "./DistroInfo.vue?vue&type=template&id=27fec934&scoped=true"
import script from "./DistroInfo.vue?vue&type=script&lang=js"
export * from "./DistroInfo.vue?vue&type=script&lang=js"

import "./DistroInfo.vue?vue&type=style&index=0&id=27fec934&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fec934"]])

export default __exports__